import { useEffect } from 'react';
import { useNetworkStatus } from '@/hooks/use-network-status';
import { toast } from 'sonner';
import { WifiOff, Wifi } from 'lucide-react';

/**
 * Shows toast notifications when network status changes
 */
export function NetworkStatusIndicator() {
  const { isOnline, wasOffline } = useNetworkStatus();

  useEffect(() => {
    if (!isOnline) {
      toast.error('No Internet Connection', {
        description: 'Some features may not work properly',
        icon: <WifiOff className="h-5 w-5" />,
        duration: Infinity, // Keep showing while offline
        id: 'network-offline'
      });
    } else if (wasOffline) {
      // Reconnected
      toast.dismiss('network-offline');
      toast.success('Back Online', {
        description: 'Reconnected to internet',
        icon: <Wifi className="h-5 w-5" />,
        duration: 3000
      });
    }
  }, [isOnline, wasOffline]);

  return null; // This is a notification-only component
}
